<template>
    <el-tree v-bind="$attrs" v-on="$listeners" class="custom-tree">
        <div class="custom-tree-node" slot-scope="{ node, data }">
            <template v-if="data.nodeType === 'folder'">
                <div class="c-tree-content">
                    <span>{{ node.label }}</span>
                    <span v-if="node.childNodes.length > 0">
                        (
                        <span class="num"> {{ node.childNodes.length }}</span>
                        )
                    </span>
                </div>
            </template>
            <template v-else>
                <div class="c-tree-content c-tree-node-item__color1">
                    <img :src="require('../../imgs/item.png')" alt="" />
                    <span>{{ node.label }}</span>
                </div>
            </template>
        </div>
    </el-tree>
</template>

<script>
export default {
    components: {},
    props: {},
    data() {
        return {};
    },
    computed: {},
    methods: {},
    created() {},
    mounted() {},
    watch: {},
};
</script>

<style lang="scss" scoped>
.custom-tree {
    background: none;
    color: #fff;
    ::v-deep .el-tree-node {
        &:focus {
            > .el-tree-node__content {
                background-color: transparent !important;
            }
        }
    }
    ::v-deep .el-tree-node__content {
        flex-direction: row-reverse;
        &:hover {
            background: none;
        }
        .el-tree-node__expand-icon.is-leaf {
            display: none;
        }
    }
    .custom-tree-node {
        flex: 1;
    }
    .c-tree-content {
        height: 26px;
        padding-left: 5px;
        display: flex;
        box-sizing: border-box;
        align-items: center;
        .num {
            color: hsl(184, 97%, 64%);
        }
    }
    .c-tree-node-item {
        &__color1 {
            background-image: linear-gradient(
                90deg,
                hsla(160, 65%, 61%, 60%) 0%,
                hsla(160, 65%, 61%, 30%) 30%,
                hsla(160, 65%, 61%, 30%) 70%,
                hsla(160, 65%, 61%, 60%)
            );
            border: 1px solid hsla(160, 65%, 61%, 100%);
            border-left-width: 5px;
            vertical-align: middle;
        }
        &__color2 {
            background-image: linear-gradient(
                90deg,
                hsla(209, 100%, 51%, 60%) 0%,
                hsla(209, 100%, 51%, 30%) 30%,
                hsla(209, 100%, 51%, 30%) 70%,
                hsla(209, 100%, 51%, 60%)
            );
            border: 1px solid hsl(209, 100%, 51%);
            border-left-width: 5px;
        }
        &__colorerror {
            background-image: linear-gradient(
                90deg,
                hsla(339, 73%, 47%, 60%) 0%,
                hsla(339, 73%, 47%, 30%) 30%,
                hsla(339, 73%, 47%, 40%) 70%,
                hsla(339, 73%, 47%, 60%)
            );
            border: 1px solid hsl(339, 73%, 47%);
            border-left-width: 5px;
        }
        &__colordisable {
            background-image: linear-gradient(
                90deg,
                hsla(218, 31%, 48%, 60%) 0%,
                hsla(218, 31%, 48%, 30%) 30%,
                hsla(218, 31%, 48%, 30%) 70%,
                hsla(218, 31%, 48%, 60%)
            );
            border: 1px solid hsl(218, 31%, 48%);
            border-left-width: 5px;
        }
    }
}
</style>
